const R = 600;
const smallR = 125;
const bigR = 250;
const middleR = 185;

const countX = (index: number, count: number, r: number) =>
	R +
	r *
		Math.cos(
			((-360 / count - 90) * Math.PI) / 180 + index * ((Math.PI * 2) / count),
		);

const countY = (index: number, count: number, r: number) =>
	R +
	r *
		Math.sin(
			((-360 / count - 90) * Math.PI) / 180 + index * ((Math.PI * 2) / count),
		);

const smallX = (index: number, count: number) => countX(index, count, smallR);

const smallY = (index: number, count: number) => countY(index, count, smallR);

const bigX = (index: number, count: number) => countX(index, count, bigR);

const bigY = (index: number, count: number) => countY(index, count, bigR);

const iconX = (index: number, count: number) =>
	countX(index + 0.5, count, middleR) - 15;
const iconY = (index: number, count: number) =>
	countY(index + 0.5, count, middleR) - 15;

const generatePath = (count: number, index: number) =>
	`M${smallX(index, count)},${smallY(index, count)} L${bigX(
		index,
		count,
	)},${bigY(index, count)} A${bigR},${bigR} 0 0,1 ${bigX(
		index + 1,
		count,
	)},${bigY(index + 1, count)} L${smallX(index + 1, count)},${smallY(
		index + 1,
		count,
	)} A${smallR},${smallR} 0 0,0 ${smallX(index, count)},${smallY(
		index,
		count,
	)} z`;

export { generatePath, iconX, iconY };
